<template>
<div class="page_order page">
    <van-tabs v-model="active" swipe-threshold="5" @click="onTabsClick">
        <van-tab title="定制中" name="1"></van-tab>
        <van-tab title="待发货" name="2"></van-tab>
        <van-tab title="完成" name="3"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
		<!-- 订单状态 -->
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list" >
                <div class="item" v-for="(order,index) in orderList" :key="index" >
                    <div class="item_t" @click="goOrderDetail(order)">
                        <div class="item_t_t">
                            <img :src="(order.tradesman&&order.tradesman.thumb) ? ( $publicData.withHttpStart(order.tradesman.thumb) ? order.tradesman.thumb : imageUrl+order.tradesman.thumb):$publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title" v-if="order.tradesman">{{ order.tradesman.nickname }}</div>
                        </div>
                        <div class="status">{{ order.orderStatus }}</div>
                    </div>
                    <!-- 商品信息 -->
                    <div class="item_nr" @click="goOrderDetail(order)">
                        <div class="item_nr_l">
							<van-image :src="order.made.thumb?imageUrl+order.made.thumb:$publicData.intangibleDefault" class="tu" fit="cover"/>
                        </div>
                        <div class="item_nr_r dingzhi">
                            <div class="info">
                                <div class="title slh_s">{{ order.made.title }}</div>
                                <div class="desc slh">{{ order.made.descript }}</div>
                            </div>
                            <div class="jiage">预估价格: <span class="price">¥{{ order.made.price_range }}</span><span class="nums f-r">{{ order.num ? 'x'+ order.num : 'x'+ 1}}</span></div>
                        </div>
                    </div>
                    <div class="item_b">
                        <div class="sum"><span class="sum_r">定制价格：¥ <span class="total_price">{{ order.total_prices }}</span></span></div>
						<!-- 操作,在详情里,列表上不加了 -->
                        <!-- <div class="actions">
							<div class="action" v-if="order.made_status == 1" @click="clickOrderMake(order)">定制完成</div>
							<div class="action" v-if="order.made_status == 2 && order.ship_status == 0 && order.pay_status == 3" @click="clickOrderShip(order)">发货</div>
                        </div> -->
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            // active: this.$route.query.status ? (this.$route.query.status).toString() : '1',
            page:1,
            size:10,
            orderList:[],
            finished: false,
            page: 1,
            size: 10,
            loading: false,
			refreshing: false,
			active: this.$route.query.status ? (this.$route.query.status).toString() : '1',
        };
    },
    created: function () {
		// console.log('this.active',this.active,typeof(this.active))
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '定制订单'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.onRefresh()
        }
	},
	mounted: function(){
		
	},
    methods: {
        onTabsClick(name, title) {
            this.active = name
            this.onRefresh()
        },
        onRefresh() {
			// 清空列表数据
			this.finished = false;
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.page = 1
			this.getData()
            
        },
        // 获取列表
        getData() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var token = this.$store.getters.token;
            var params = {
                token: this.token,
                page: this.page,
                size: this.size,
                status: this.active
            }
			this.$api.tradesman.tradeorder(params).then(res=>{
				if(res.code == 200){
                    // this.orderList = res.result
                    var list = res.result
                    var old = this.orderList
                    if (this.page == 1) {
                        old = []
                    } 
                    for (let i = 0; i < list.length; i++) {
                        var order = list[i]
                        if (order.made  ) {
                            var album = order.made.album
							if(album){
								var images = album.split(",").filter(item=> item!="");
								order.made.thumb = images[0]
							}else{
								order.made.thumb = ''
							}
                        } else if (order.customizedcommunity) {
                            order.made = {
                                title: order.customizedcommunity.title,
                                descript:order.customizedcommunity.content,
                                price_range: order.customizedcommunity.price,
                                thumb: ''
                            }
                            var album = order.customizedcommunity.album
                            console.log(album)
							if(album){
								var images = album.split(",").filter(item=> item!="");
								order.made.thumb = images[0]
							}else{
								order.made.thumb = ''
							}
						}
						if (order.order_status == 0) {
                            order.orderStatus = '已取消'
                        }else if(order.made_status == 1){
							order.orderStatus = '定制中'
						}else if (order.pay_status == 2) {
                            order.orderStatus = '待付尾款'
                        }else if(order.ship_status == 0){
							order.orderStatus = '待发货'
						}else{
							order.orderStatus = '已完成'
						}
                        old.push(order)
                    }
                    this.orderList = old
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
				} else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
			})
		},
		// 去订单详情
		goOrderDetail(order){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/tradesman/dingzhi/order/detail?id=' + order.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/tradesman/dingzhi/order/detail',
                    query: {
                            id: order.id
                        }
                })
            }
        },
		// 定制完成
		clickOrderMake(order){
			var that = this
			var params = {
				token: that.token,
				id: order.id,
				status: 2 // 定制状态 1定制中 2完成
			}
			that.$api.tradesman.ordermake(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message)
					// 重新刷新数据
					that.loading = true;
					that.page = 1
					that.getData()
				}else{
					that.$toast(res.message)
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
